import { Link, useLocation, useNavigate } from "react-router-dom";
import { useState } from "react";

function Navbar({ setIsLoggedIn }) {

  const location = useLocation();
  const navigate = useNavigate();
  const [showSettings, setShowSettings] = useState(false);
  //const role = localStorage.getItem("role");
  const token = localStorage.getItem("token");

  let permissions = [];

  if (token) {
    try {
      const decoded = JSON.parse(atob(token.split(".")[1]));
      permissions = decoded.permissions || [];
    } catch (e) {
      permissions = [];
    }
  }



  const handleLogout = () => {
    localStorage.clear();

    setIsLoggedIn(false);
    navigate("/login");
  };

  const linkStyle = (path) => ({
    color: location.pathname === path ? "#fff" : "#ddd",
    background: location.pathname === path ? "#2563eb" : "transparent",
    padding: "8px 12px",
    borderRadius: "5px",
    marginRight: "10px",
    textDecoration: "none",
    transition: "0.3s"
  });

  return (
    <div style={navBar}>

      <h3 style={{ color: "#60a5fa", marginRight: "20px" }}>
        Shiv Modern Academy
      </h3>

      <Link to="/" style={linkStyle("/")}>Dashboard</Link>
      <Link to="/students" style={linkStyle("/students")}>Students</Link>
      <Link to="/fees" style={linkStyle("/fees")}>Pay Fees</Link>
      <Link to="/receipts" style={linkStyle("/receipts")}>Receipts</Link>
      {permissions.includes("VIEW_REPORTS") && (
        <Link to="/reports" style={linkStyle("/reports")}>Reports</Link>
      )}
      {permissions.includes("MANAGE_USERS") && (
        <Link to="/users" style={linkStyle("/users")}>Users</Link>
      )}


      {/* ⚙ SETTINGS DROPDOWN */}
      <div
        style={{ position: "relative" }}
        onMouseEnter={() => setShowSettings(true)}
        onMouseLeave={() => setShowSettings(false)}
      >
        <div style={dropdownBtn}>
          ⚙ Settings ▾
        </div>

        {showSettings && (
          <div style={dropdownMenu}>
            <Link
              to="/fee-structure"
              style={dropdownItem}
              onMouseEnter={(e) => e.target.style.background = "#eff6ff"}
              onMouseLeave={(e) => e.target.style.background = "transparent"}
            >
              Fee Structure
            </Link>

            <Link
              to="/conveyance"
              style={dropdownItem}
              onMouseEnter={(e) => e.target.style.background = "#eff6ff"}
              onMouseLeave={(e) => e.target.style.background = "transparent"}
            >
              Conveyance
            </Link>
          </div>
        )}
      </div>

      {/* LOGOUT */}
      <button onClick={handleLogout} style={logoutBtn}>
        Logout
      </button>

    </div>
  );
}

/* 🎨 STYLES */

const navBar = {
  background: "#1f2937",
  padding: "15px",
  display: "flex",
  alignItems: "center"
};

const dropdownBtn = {
  color: "#ddd",
  padding: "8px 12px",
  cursor: "pointer"
};

const dropdownMenu = {
  position: "absolute",
  top: "35px",
  background: "#fff",
  borderRadius: "6px",
  boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
  minWidth: "160px",
  zIndex: 100
};

const dropdownItem = {
  display: "block",
  padding: "10px",
  color: "#333",
  textDecoration: "none",
  transition: "0.2s",
  cursor: "pointer"
};

const logoutBtn = {
  marginLeft: "auto",
  padding: "8px 12px",
  background: "#dc2626",
  color: "white",
  border: "none",
  borderRadius: "5px",
  cursor: "pointer"
};

export default Navbar;